import type { SyncActivityKind, SyncActivityStatus, SyncRecipientState } from '@/lib/types'

/**
 * Visual SoT for sync activity: status → icon + tone + Tag severity, kind →
 * icon, a locker's receipt state → icon + tone. Labels live in i18n
 * (`syncActivity.status.*`, `syncActivity.kind.*`, `syncLog.detail.*`).
 */
export const SYNC_STATUS_VISUAL: Record<
  SyncActivityStatus,
  { icon: string; tone: string; tag: 'info' | 'success' | 'warn' | 'danger' }
> = {
  in_progress: { icon: 'pi pi-sync', tone: 'text-info', tag: 'info' },
  done: { icon: 'pi pi-check-circle', tone: 'text-success', tag: 'success' },
  partial: { icon: 'pi pi-exclamation-circle', tone: 'text-warning', tag: 'warn' },
  failed: { icon: 'pi pi-times-circle', tone: 'text-danger', tag: 'danger' },
}

export const SYNC_KIND_ICON: Record<SyncActivityKind, string> = {
  data: 'pi pi-database',
  config: 'pi pi-sliders-h',
  branding: 'pi pi-palette',
  ota: 'pi pi-download',
}

/** `missing` = still pending on a settled entry: the locker never received it. */
export const SYNC_RECIPIENT_VISUAL: Record<SyncRecipientState | 'missing', { icon: string; tone: string }> = {
  acked: { icon: 'pi pi-check-circle', tone: 'text-success' },
  failed: { icon: 'pi pi-times-circle', tone: 'text-danger' },
  pending: { icon: 'pi pi-clock', tone: 'text-muted' },
  missing: { icon: 'pi pi-exclamation-circle', tone: 'text-warning' },
}
